"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveThreadFolder = resolveThreadFolder;
exports.resolveThreadUlid = resolveThreadUlid;
const path = __importStar(require("path"));
/**
 * Resolve a thread's stable `th_` ULID to its folder within a weave.
 *
 * Scans `loom/{weaveSlug}/*​/thread.md` for the manifest whose `id === threadUlid`
 * and returns that thread's folder slug + absolute path. This is the single
 * ULID→folder chokepoint every doc-create / promote use-case routes through, so
 * the API can be referenced by the stable ULID (what the agent holds) rather than
 * by the renameable folder slug.
 *
 * Throws if the weave is missing or no thread matches — a doc-create NEVER
 * fabricates a thread from an unresolvable reference (the core invariant of the
 * api-contract-refactor: the originating bug was a create silently minting a
 * duplicate ULID-named thread instead of erroring).
 */
async function resolveThreadFolder(weaveSlug, threadUlid, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const weaveDir = path.join(loomRoot, 'loom', weaveSlug);
    if (!(await deps.fs.pathExists(weaveDir))) {
        throw new Error(`Weave '${weaveSlug}' not found.`);
    }
    const entries = await deps.fs.readdir(weaveDir).catch(() => []);
    for (const slug of entries) {
        const manifestPath = path.join(weaveDir, slug, 'thread.md');
        if (!(await deps.fs.pathExists(manifestPath)))
            continue;
        try {
            const doc = (await deps.loadDoc(manifestPath));
            if (doc.id === threadUlid) {
                return { threadSlug: slug, threadPath: path.join(weaveDir, slug) };
            }
        }
        catch {
            // skip a malformed manifest — a bad thread.md must not mask a good match elsewhere
        }
    }
    throw new Error(`No thread with ulid '${threadUlid}' in weave '${weaveSlug}'. ` +
        `A doc-create never fabricates a thread — create the thread first ` +
        `(createThread) and pass its returned thread_ulid.`);
}
/**
 * Resolve a thread's folder SLUG to its stable `th_` ULID — the inverse of
 * {@link resolveThreadFolder}. Reads `loom/{weaveSlug}/{threadSlug}/thread.md` and
 * returns its `id`. Throws if the manifest is missing. This is the human→identity
 * direction: the CLI/`loom resolve-ulid` accept a slug a person typed and turn it
 * into the ULID the API contract wants.
 */
async function resolveThreadUlid(weaveSlug, threadSlug, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const manifestPath = path.join(loomRoot, 'loom', weaveSlug, threadSlug, 'thread.md');
    if (!(await deps.fs.pathExists(manifestPath))) {
        throw new Error(`No thread '${weaveSlug}/${threadSlug}' (no thread.md). Create it first with createThread.`);
    }
    const doc = (await deps.loadDoc(manifestPath));
    return doc.id;
}
